/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Table, Form, Icon
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const UtilsInstance = new Utils();

const eventTypeRegex = new RegExp("^[A-Za-z][A-Za-z- ]*");

class Dados extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isColumnClicked: false,
      baudrate: 0,
      nMasters: 0,
      nSlaves: 0,
      errorMessages: [],
      firstScanFail: false,
      uptime: "",
      language: UtilsInstance.getLanguageStringFromKey(
        Constants,
        Strings),
    };
  }

  // Since the devices in PA protocol are not numbered with simple integers
  // We need to convert, 1A and 1B for exemple, into sortable integers
  // Every device that has A in its address has its number as the sortable integer
  // Every device that has B in its addres, has its number + 32 as the sortable integer
  // Every device that has master in its name has its number be 0
  addOrderAndSeverityToDevices = (devices) => {

    for (let i = 0; i < devices.length; i++) {
      // Adding order value
      let deviceName = devices[i].address;

      devices[i].order = parseInt(deviceName);
    }
    devices.sort(UtilsInstance.sortBy("order", false, parseInt));
  }

  // Creates a list with entries that match the address passed on the form
  handleAddressSearch = () => {
    const searchedDevices = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      if (this.state.originalDevices[i].address === parseInt(this.state.formInput)) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleLimitSearch = () => {
    const searchedLimit = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      let cont = 0;
      for (let j = 0; j < this.state.originalDevices[i].infoDados.length; j++) {
        if (this.state.originalDevices[i].infoDados[j].limit.toUpperCase().includes(this.state.formInput.toUpperCase())) {
          cont += 1;
        }
      }
      if (cont > 0) {
        searchedLimit.push(this.state.originalDevices[i]);
      }

    }

    if (searchedLimit.length > 0) {
      this.setState({ devices: searchedLimit });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    Filters the page list showing only the devices that match the address or status typed in the form
  */
  handleSubmit = () => {

    if (this.state.formInput !== "" && eventTypeRegex.test(this.state.formInput)) {
      this.handleLimitSearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
    // If what the user typed is not a status and the form is not blank, try to see if he typed a number
    else {
      this.handleAddressSearch();
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user didn't 
    // sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {
      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "dados/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
          .catch((error) => {
            console.log(error);
          })
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let dados = resolvedPromisses[0];
      this.addOrderAndSeverityToDevices(dados);

      this.setState({
        devices: dados,
        originalDevices: dados,
      });
    }
  }

  /*
    Adjusts the size of the table so that it does not exceed the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_DADOS;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    this.setState({
      intervalID: setInterval(this.retrieveData, 1000),
    });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
    clearInterval(this.state.warningsIntervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  createStatusCell = (status) => {
    if (status === Constants.GOOD_DADOS) {
      return <Icon name="check circle" color="green" size="big" />;
    }
    else {
      return <Icon name="exclamation circle" color="yellow" size="big" />;
    }
  }

  createLimitCell = (info) => {
    if (this.state.language === Strings.SPANISH) {
      return <Table.Cell width={2} textAlign="center">{info.limitES}</Table.Cell>;
    } else if (this.state.language === Strings.ENGLISH) {
      return <Table.Cell width={2} textAlign="center">{info.limitEN}</Table.Cell>;
    } else {
      return <Table.Cell width={2} textAlign="center">{info.limit}</Table.Cell>;
    }
  }

  createInfoStatusCell = (info) => {
    if (this.state.language === Strings.SPANISH) {
      return <Table.Cell width={2} textAlign="center">{info.statusES}</Table.Cell>;
    } else if (this.state.language === Strings.ENGLISH) {
      return <Table.Cell width={2} textAlign="center">{info.statusEN}</Table.Cell>;
    } else {
      return <Table.Cell width={2} textAlign="center">{info.status}</Table.Cell>;
    }
  }

  // Render the table containing all network devices
  render() {
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Body key={device.address}>
        <Table.Row style={mainTableRowStyle}>
          <Table.Cell width={2} textAlign="center">{device.address}</Table.Cell>
          <Table.Cell width={2} textAlign="center">{device.tag}</Table.Cell>
          <Table.Cell width={7} colSpan="4" />
        </Table.Row>
        {device.infoDados.map((info, index) => (
          <Table.Row key={`${device.address}-${index}`}>
            <Table.Cell width={2} textAlign="center">{Strings.VAR} {info.variavel}</Table.Cell>
            <Table.Cell width={2} textAlign="center"></Table.Cell>
            <Table.Cell width={2} extAlign="center">{UtilsInstance.formatDadosValue(info.valor)}</Table.Cell>
            {this.createLimitCell(info)}
            {this.createInfoStatusCell(info)}
            <Table.Cell width={1} textAlign="center">{this.createStatusCell(info.status)}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    ));
    return (
      <div style={screenStyle}>
        <Form style={searchStyle} onSubmit={this.handleSubmit} >
          <Form.Input
            id="inputform"
            placeholder={Strings.DADOS_INPUT_TEXT_PLACEHOLDER}
            icon="search"
            name="formInput"
            value={filter}
            onChange={this.handleChange} />
        </Form>

        <Table id="table-header" style={headerMarginStyle} stackable striped celled textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2} textAlign="center">{Strings.ADDRESS}</Table.HeaderCell>
              <Table.HeaderCell width={2} textAlign="center">{Strings.TAG}</Table.HeaderCell>
              <Table.HeaderCell width={2} textAlign="center">{Strings.VALOR}</Table.HeaderCell>
              <Table.HeaderCell width={2} textAlign="center">{Strings.LIMIT}</Table.HeaderCell>
              <Table.HeaderCell width={2} textAlign="center">{Strings.STATUS_INFORMATION}</Table.HeaderCell>
              <Table.HeaderCell width={1} textAlign="center">{Strings.STATUS_DADOS}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" stackable striped celled textAlign="center">
            {devices}
          </Table>
        </div>
      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginBottom: "1vh",
  width: "99.4%"
};

const mainTableRowStyle = {
  backgroundColor: "#BDBDBD"
};

const searchStyle = {
  width: "33%",
  margin: "0 auto",
  marginBottom: "16px"
};

const mapStateToProps = state => ({
  channel: state.activeMenuItem.channel
});

export default connect(mapStateToProps)(withRouter(Dados));